import React, { Component } from 'react';
import $ from 'jquery';

class SelectSeriesModal extends Component {

    renderSeries = () => {
        const { seriesArray, seriesDefault, onchange } = this.props;

        return (<select name="select" id="selectCreateInvoiceTimbrado" value={seriesDefault} onChange={onchange} className="btn btn-outline-secondary dropdown-toggle listSerie" >
            <option value={"option"}>--</option>
            {seriesArray.map((serie, index) => {
                return (
                    <option value={serie.Series} key={index}>{serie.SeriesName}</option>
                )
            })}
        </select>)

    }


    render() {
        const { billing, view } = this.props;
        const { seriesArray, seriesDefault, onchange } = this.props;
        let active = false;
        if (seriesDefault !== 'option') {
            active = true;
        }
        return (
            <div className="modal fade bd-example-modal-xl" id="selectSeriesModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content " >
                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">Selecciona Serie</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ height: 230, maxHeight: 230 }}>
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div >
                                            <label htmlFor="">Selecciona la Serie para Facturación &nbsp;</label>
                                            {this.renderSeries()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar" data-dismiss="modal">
                                Cerrar
                            </button>
                            {/*} {(view !== "orderSales" && view !== "deliveries") && <button type="button" disabled={!active} className="btn botonCorrect" data-dismiss="modal" onClick={() => billing(1)}>
                                Timbrar
                            </button>}*/}
                            {(view === "orderSales" || view === "deliveries") && <button type="button" disabled={!active} className="btn botonCorrect" data-dismiss="modal" onClick={() => billing(2)}>
                                Facturar
                            </button>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SelectSeriesModal;